import { IConfiguredHttp } from './http';

export interface IPayLater {
	outcome: string;
	eventId: string;
	paymentDate?: string;
}

export interface IPayLaterAPI {
	sendPayLaterEvent: (eventId: string, hash: {}) => Promise<IPayLater>;
}

const payLaterApiFactory = (http: IConfiguredHttp): IPayLaterAPI => ({
	sendPayLaterEvent(eventId, queryHash) {
		const data = queryHash;
		return http.post(`/pay_later/${eventId}`, data);
	},
});

export default payLaterApiFactory;
